import { useEffect, useState } from "react";
import { APIGet } from "@tccshared/services/API";

export const getConfiguration = async (site) => {

    try {
        const res = await APIGet(site + '/api/v1/configure')
        const json = await res.json();
        return { status: 'success', data: json };
    } catch (error) {
        return error;
    }

}



export const useConfiguration = (site) => {

    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);

    const load = async () => {
        setLoading(true);
        const res = await getConfiguration(site);

        if (res.status === 'success') {
            setResult(res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!site) return;
        load();
    }, [site])

    return {
        loading,
        result
    }

}
